import React, { useEffect, useState } from "react";
import "./login.scss";
import { rightarrowwhite } from "../../images";
import FullWidthTextField from "../../components/TextField/FullWidthTextField";
import FooterV2 from "../../components/FooterV2/FooterV2";
import BlinkingDots from "../../Animations/BlinkingDots/BlinkingDots";
import { Link } from "react-router-dom";
import PasswordInput from "../../components/PasswordInput/PasswordInput";
import { privacypolicyURL } from "../../components/helpers/constant-words";
import config from "../../config/config";

import Joi from "joi";
import http from "../../helpers/http";
import { useWindowSize } from "react-use";
import { useAuth } from "../../context/Auth/AuthState";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import useTheme from "../../components/useTheme/useTheme";

const BusinessTestLogin = () => {
  const { width } = useWindowSize();
  const { theme } = useTheme();
  const [deviceId, setDeviceId] = useState(null);
  const auth = useAuth();
  const [values, setValues] = useState({
    username: "",
    password: "",
  });

  const [formError, setFormError] = useState({});
  const joiOptions = config.joiOptions;
  const base_url = config.api_url;

  const handleChange = (e) => {
    setValues((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handlePasswordChange = (event) => {
    values.password = event.target.value;
  };

  const validate = async (data) => {
    const schemaObj = {
      username: Joi.string().trim().required().label("Username"),
      password: Joi.string().trim().required().label("Password"),
    };

    const schema = Joi.object(schemaObj).options({ allowUnknown: true });
    const { error } = schema.validate(data, joiOptions);

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    return errors ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = await validate(values);
    setFormError(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const userProfiles = JSON.parse(
      localStorage.getItem("userProfiles") || "[]"
    );
    const profilesArray = Object.values(userProfiles);
    const businessAccounts = profilesArray.filter(
      (profile) => "isVerified" in profile
    ).length;
    if (businessAccounts >= 4) {
      setFormError({ password: "Only 4 business accounts are allowed." });
      return;
    }

    values["deviceId"] = deviceId;
    const data = await http.post(base_url + "/business/login", values);
    if (data) {
      if (data?.data?.error) {
        setFormError({ password: data?.data?.error });
        return;
      }
      auth.businessLogin(data.data);
    }
  };

  useEffect(() => {
    const getFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      setDeviceId(result.visitorId);
    };

    getFingerprint();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BlinkingDots />
      <main className="user_login_container">
        <section className="login_sec1">
          <div className="my_container">
            <div className="text_container">
              <h2 className="sub_title">Business Test Login</h2>
              <h3 className={`title ${theme === "light" ? "text-black" : ""}`}>
                Login to your Business Account
              </h3>
            </div>

            <div className="contact_wrapper">
              <form onSubmit={handleSubmit} noValidate autoComplete="on">
                <div className="row field_row">
                  <div className="col-md-12 field_col">
                    <div
                      className={`field_wrapper ${
                        theme === "light" && "field_wrapper_light_mode"
                      }`}
                    >
                      <FullWidthTextField
                        lightTheme={theme === "light" ? true : false}
                        label="Username*"
                        type="text"
                        name="username"
                        onChange={handleChange}
                        value={values.username}
                        autoComplete="login-username"
                      />
                      {formError && (
                        <p className="error">{formError.username}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 field_col">
                    <div
                      className={`field_wrapper ${
                        theme === "light" && "field_wrapper_light_mode"
                      }`}
                    >
                      <PasswordInput
                        lightTheme={theme === "light" ? true : false}
                        label="Password*"
                        hideIcon={false}
                        name="password"
                        value={values.password}
                        onChange={handlePasswordChange}
                        autoComplete="current-password"
                      />
                      {formError && (
                        <p className="error">{formError.password}</p>
                      )}
                    </div>
                  </div>
                </div>
                <a
                  href="https://business.archinza.com/forgot-password"
                  className={`reset_notice ${
                    theme === "light" && "text-black"
                  }`}
                >
                  Forgot password?
                </a>
                <p
                  className={`terms_text ${
                    theme === "light" && "text-black"
                  }`}
                >
                  By continuing, you agree to {width < 600 && <br />}the terms
                  of{" "}
                  <Link
                    to={privacypolicyURL}
                    className="link clr_orange"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Archinza Policy.
                  </Link>
                </p>
                <div className="cta_wrapper">
                  <div className="btn_wrapper">
                    <button className="form_btn" onClick={handleSubmit}>
                      Login
                      <img
                        src={rightarrowwhite}
                        alt="icon"
                        className="icon"
                        loading="lazy"
                      />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        {theme === "dark" ? (
          <FooterV2 whatsappBotIcon={false} />
        ) : (
          <FooterV2 lightTheme whatsappBotIcon={false} />
        )}
      </main>
    </>
  );
};
export default BusinessTestLogin;
